import React from "react";
import SalaryComponentListData from "./SalaryComponentListData";


const SalaryComponentList = ({ salarycomponentData,onEdit }) => {
  return (
    <div className="relative overflow-x-auto">
      <table className="w-full text-sm text-left text-gray-500 dark:text-gray-500">
        <thead className="text-xs font-medium uppercase bg-gray-50 dark:bg-gray-50 text-gray-600 border-b border-t dark:border-gray-200 tracking-wider">
          <tr>
            <th scope="col" className="px-10 py-3">
              EARNING TYPE
              <i className="ico-down text-blue-600 cursor-pointer pl-2"></i>
            </th>
            <th scope="col" className="px-10 py-3">
              CALCULATION VALUE
              <i className="ico-down text-blue-600 cursor-pointer pl-2"></i>
            </th>
            <th scope="col" className="px-10 py-3">
              CALCULATION FROM
              <i className="ico-down text-blue-600 cursor-pointer pl-2"></i>
            </th>
            <th scope="col" className="px-10 py-3">
              CONSIDER FOR Statutory Deducation
              <i className="ico-down text-blue-600 cursor-pointer pl-2"></i>
            </th>
          
            <th scope="col" className="px-10 py-3">
              IS ACTIVE
              <i className="ico-down text-blue-600 cursor-pointer pl-2"></i>
            </th>
            <th scope="col" className="px-10 py-3 text-right">
              <i className="ico-grid text-blue-600 cursor-pointer pl-2"></i>
            </th>
          </tr>
        </thead>
        <tbody>
        {salarycomponentData.map((val, key) => (
            <SalaryComponentListData
              key={val.component_id || key}
              requestdata={val}
              onEdit={() => onEdit(val)} 
            />
          ))}
        </tbody>
      </table>

    
    </div>
  );
};

export default SalaryComponentList;
